import {CONF} from '@/constants/conf';
import {IMainMenuItem, IMainMenuItemI18N, mainMenu} from '@/constants/menu';
import {i18n} from '@/plugin/i18n';

class PBLocales {

    public lang: string = CONF.LANGUAGE_DEFAULT;
    public market: string = CONF.MARKET_DEFAULT;

    constructor() {
        this._mainMenu = this.mainMenu;
    }

    protected _urlSegment: string = '';

    get urlSegment() {
        return this.lang + '-' + this.market;
    }

    protected _mainMenu: Array<IMainMenuItem> = [];

    get mainMenu() {
        this._mainMenu = [];
        // on récupère les entrées du menu traduit
        const i18Menu = i18n.messages[i18n.locale].menu as any;

        // on construit un menu qui est en fait le menu global, on l'on récupere des propriétés traduits (segment / title)
        mainMenu.map((item) => {
            if (typeof item.pageComponent !== 'object' || item.pageComponent[this.market as keyof IMainMenuItemI18N]) {
                // on recupère le pageComponent
                let pageComponent;
                if (typeof item.pageComponent === 'object') {
                    pageComponent = item.pageComponent[this.market as keyof IMainMenuItemI18N];
                } else {
                    pageComponent = item.pageComponent;
                }

                // on recupère l'image
                let image;
                if (typeof item.image === 'object') {
                    image = item.image[this.market as keyof IMainMenuItemI18N];
                } else {
                    image = item.image;
                }

                let title;
                if (typeof i18Menu[pageComponent].title === 'object') {
                    title = i18Menu[pageComponent].title[this.market];
                } else {
                    title = i18Menu[pageComponent].title;
                }


                this._mainMenu.push({
                    pageComponent: pageComponent,
                    image: image,
                    imageOffset: item.imageOffset,
                    imageBottom: item.imageBottom,
                    imageScale: item.imageScale,
                    layout: item.layout,
                    color: item.color,
                    wordsCount: item.wordsCount,
                    layoutImage: item.layoutImage,
                    layoutIndex: item.layoutIndex,
                    theme: item.theme,
                    intro: item.intro,
                    segment: i18Menu[pageComponent].segment,
                    title: title,
                    tag: item.tag,
                });
            }
        });

        return this._mainMenu;
    }

    public getPageInfos(componentPage: string): IMainMenuItem | boolean {
        const filtered = this._mainMenu.filter((item) => (
                item.pageComponent === componentPage
            ),
        );
        return (filtered.length === 1 ? filtered[0] : false);
    }


}


export const Locales = new PBLocales();
